import { render, staticRenderFns } from "./Conferences.vue?vue&type=template&id=dd7ffa12&scoped=true"
import script from "./Conferences.vue?vue&type=script&lang=js"
export * from "./Conferences.vue?vue&type=script&lang=js"
import style0 from "./Conferences.vue?vue&type=style&index=0&id=dd7ffa12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd7ffa12",
  null
  
)

export default component.exports